const PermList = {

    GROUP_LIST: "academy_group_list",
    GROUP_CREATE: "academy_group_create",
    GROUP_EDIT: "academy_group_edit",

    GRADE_LIST: "academy_grade_list",
    GRADE_CREATE: "academy_grade_create",
    GRADE_EDIT: "academy_grade_edit",

    COURSE_LIST: "academy_course_list",

    TOPIC_LIST: "academy_topic_list",
    TOPIC_VIEW: "academy_topic_view",
    TOPIC_EDIT: "academy_topic_edit",

    TOPIC_CONTENT_CREATE: "academy_topic_content_create",
    TOPIC_CONTENT_EDIT: "academy_topic_content_edit",
    TOPIC_CONTENT_DELETE: "academy_topic_content_delete",

    CERTIFICATION_LIST: "academy_certification_list",

    LESSON_LIST: "academy_lesson_list",

    MEMBER_LIST: "academy_member_list",
    MEMBER_VIEW: "academy_member_view",
    MEMBER_PERMISSION_EDIT: 'academy_member_permission_edit',

    DISCOUNT_LIST: "academy_discount_list",
    DISCOUNT_ADD: "academy_discount_add",
    DISCOUNT_VIEW: "academy_discount_view",
    DISCOUNT_EDIT: "academy_discount_edit",
    DISCOUNT_DELETE: "academy_discount_delete",

    CLASSROOM_LIST: "academy_classroom_list",
    CLASSROOM_ADD: "academy_classroom_add",
    CLASSROOM_VIEW: "academy_classroom_view",
    CLASSROOM_EDIT: "academy_classroom_edit",
    CLASSROOM_DELETE: "academy_classroom_delete",

    REFUND_ADD: "academy_refund_add",
    REFUND_LIST: "academy_refund_list",
    REFUND_VIEW: "academy_refund_view",
    REFUND_EDIT: "academy_refund_edit",
    REFUND_DELETE: "academy_refund_delete",


    PRODUCT_DASHBOARD : 'academy_product_dashboard',

    PRODUCT_DELIVERY_STEP_LIST : 'academy_product_delivery_step_list',
    PRODUCT_DELIVERY_STEP_ADD : 'academy_product_delivery_step_add',
    PRODUCT_DELIVERY_STEP_VIEW : 'academy_product_delivery_step_view',
    PRODUCT_DELIVERY_STEP_EDIT : 'academy_product_delivery_step_edit',

    PRODUCT_LIST : 'academy_product_list',
    PRODUCT_ADD : 'academy_product_add',
    PRODUCT_VIEW : 'academy_product_view',
    PRODUCT_EDIT : 'academy_product_edit',
    PRODUCT_DELETE : 'academy_product_delete',

    PRODUCT_DELIVERY_LIST : 'academy_product_delivery_list',
    PRODUCT_DELIVERY_ADD : 'academy_product_delivery_add',
    PRODUCT_DELIVERY_VIEW : 'academy_product_delivery_view',
    PRODUCT_DELIVERY_EDIT : 'academy_product_delivery_edit',
    PRODUCT_DELIVERY_DELETE : 'academy_product_delivery_delete',
    PRODUCT_DELIVERY_SEARCH: 'academy_product_delivery_search',
    PRODUCT_DELIVERY_RECEIPT: 'academy_product_delivery_receipt',
    PRODUCT_DELIVERY_DELIVER: 'academy_product_delivery_deliver',

    PRODUCT_DELIVERY_HISTORY_LIST : 'academy_product_delivery_history_list',
    PRODUCT_DELIVERY_HISTORY_ADD : 'academy_product_delivery_history_add',
    PRODUCT_DELIVERY_HISTORY_VIEW : 'academy_product_delivery_history_view',
    PRODUCT_DELIVERY_HISTORY_EDIT : 'academy_product_delivery_history_edit',
    PRODUCT_DELIVERY_HISTORY_DELETE : 'academy_product_delivery_history_delete',


    SURVEY_LIST: "academy_survey_list",
    SURVEY_ADD: "academy_survey_add",
    SURVEY_VIEW: "academy_survey_view",
    SURVEY_EDIT: "academy_survey_edit",
    SURVEY_DELETE: "academy_survey_delete",
    SURVEY_RESULT: "academy_survey_result",

    ROLES_LIST: "academy_roles_list",
    ROLES_ADD: "academy_roles_add",
    ROLES_VIEW: "academy_roles_view",
    ROLES_EDIT: "academy_roles_edit",
    ROLES_DELETE: "academy_roles_delete",

    SETTINGS_LIST: "academy_settings_list",
    SETTINGS_EDIT: "academy_settings_edit",
    SETTINGS_SMS_HISTORY_LIST: 'academy_settings_sms_history_list',

    EXPORTS_LIST: "academy_exports_list",
    EXPORTS_ADD: "academy_exports_add",

    ACADEMY_IMPORT_ADD: 'academy_import_add',
    ACADEMY_IMPORT_LIST: 'academy_import_list',
}

export default PermList